import { useCallback, useEffect, useState } from 'react';
import * as groupsApi from '../api/groups';
import { Spinner } from './ui';
import { cn, ui } from '../lib/ui';

export default function GroupPicker({ selected = [], onChange, exclude = [] }) {
  const [groups, setGroups] = useState(null);
  const [error, setError] = useState(null);

  const load = useCallback(() => {
    groupsApi
      .listGroups({ limit: 100 })
      .then(d => setGroups(d.groups || []))
      .catch(() => {
        setGroups([]);
        setError('Could not load groups.');
      });
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  if (groups === null) return <Spinner />;
  if (error) return <p className={cn(ui.muted, 'text-body-s')}>{error}</p>;

  const excludeSet = new Set(exclude);
  const available = groups.filter(g => !excludeSet.has(g.groupId));
  if (available.length === 0)
    return <p className={cn(ui.muted, 'text-body-s')}>No groups available.</p>;

  const selectedSet = new Set(selected);

  function toggle(groupId) {
    if (selectedSet.has(groupId)) {
      onChange(selected.filter(id => id !== groupId));
    } else {
      onChange([...selected, groupId]);
    }
  }

  return (
    <div>
      {selected.length > 0 && (
        <div className="mb-4 flex flex-wrap items-center gap-1">
          {selected.map(gid => {
            const g = groups.find(gr => gr.groupId === gid);
            return (
              <span key={gid} className={cn(ui.pillInfo, 'gap-1')}>
                {g ? g.name : gid}
                <button
                  type="button"
                  onClick={() => toggle(gid)}
                  className="cursor-pointer border-0 bg-transparent p-0 leading-none text-current"
                  aria-label={`Remove ${g ? g.name : gid}`}
                >
                  x
                </button>
              </span>
            );
          })}
        </div>
      )}
      <div className="max-h-48 overflow-y-auto">
        {available.map(g => (
          <label key={g.groupId} className="flex cursor-pointer items-center gap-2 py-1">
            <input
              type="checkbox"
              className={ui.checkbox}
              checked={selectedSet.has(g.groupId)}
              onChange={() => toggle(g.groupId)}
            />
            <span>{g.name}</span>
            <span className={cn(ui.muted, 'text-body-s')}>({g.memberCount || 0} members)</span>
          </label>
        ))}
      </div>
    </div>
  );
}
